export default {
    setPagePreloaderIsActiveMutation (state, payload)
    {
        state.pagePreloaderIsActive = payload;
    }
}
